module.exports = __webpack_public_path__ + "bj.00e04d920f0d106e7028.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/bj.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/bj.svg
// module chunks = styles